import { observer } from 'mobx-react';
import React from 'react';
import { LFControllerWrapper } from '../LFControllerWrapper';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { IBaseOption } from './utils';
import { IPlainSelectProps, LFPlainSelect } from './LFPlainSelect';
interface IPlainSelectWithRHFProps<T extends IBaseOption, FormValues extends FieldValues = FieldValues> extends IPlainSelectProps<T> {
  control: Control<FormValues>;
  inputName: FieldPath<FormValues>;
}
export const LFPlainSelectWithRHF = observer(<T extends IBaseOption, FormValues extends FieldValues = FieldValues>({
  control,
  inputName,
  ...rest
}: IPlainSelectWithRHFProps<T, FormValues>) => <LFControllerWrapper control={control} inputName={inputName}>
      <LFPlainSelect {...rest} />
    </LFControllerWrapper>);